<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t("message.add") }} {{ $tc("message.facture", 1) }}
          </h3>
        </div>
      </div>

      <div class="card-body" >
        <b-form>
          <b-container>
            <p class="heading text-center">{{ $t("message.infoGenerale") }}</p>
            <b-row >
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="souscripteur-group"
                  :label="$t('message.souscripteur')"
                  label-for="souscripteur"
                >
                  <select
                    id="souscripteur"
                    v-model="$v.form.souscripteur.$model"
                    class="form-control is-invalid retirerBordure"
                    @change="getMedicalAdvicesPatient($event)"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in mSubscribers"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback
                    v-if="$v.form.souscripteur.$error"
                  >
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                  <span
                    v-if="errorshasField('souscripteur')"
                    style="color: red"
                  >
                    {{ getErrorsField("souscripteur") }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group
                  id="nomPatient-group"
                  :label="$t('message.nomPatient')"
                  label-for="nomPatient"
                >
                  <select
                    id="nomPatient"
                    v-model="$v.form.patient_id.$model"
                    class="form-control is-invalid retirerBordure"
                    required
                  >
                    <option data-placeholder="true"></option>
                    <option
                      v-for="item in patients"
                      :key="item.user_id"
                      :value="item.user_id"
                    >
                      {{ item.slug }}
                    </option>
                  </select>
                  <b-form-invalid-feedback
                    v-if="$v.form.patient_id.$error"
                  >
                    {{ $t("message.requiredField") }}
                  </b-form-invalid-feedback>
                  <span
                    v-if="errorshasField('patient_id')"
                    style="color: red"
                  >
                    {{ getErrorsField("patient_id") }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
                                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$tc('message.amount',1)"
                                        label-for="Montant"
                                        description=""

                                >
                                    <b-form-input
                                            id="Montant"
                                            v-model="$v.form.amount.$model"
                                            :state="$v.form.amount.$dirty ? !(errorshasField('amount') || $v.form.amount.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('amount')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="!$v.form.amount.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('amount')">
                                        {{ getErrorsField('amount') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group
                                        id="dateFacturation-group"
                                        :label="$t('message.dateFacturation')"
                                        label-for="dateFacturation">
                                    <b-form-input
                                            id="dateFacturation"
                                            v-model="$v.form.date_facturation.$model"
                                            :state="$v.form.date_facturation.$dirty ? !(errorshasField('date_facturation') || $v.form.date_facturation.$error) : null"
                                            placeholder=""
                                            type="date"
                                            @focus="clearErrorField('date_facturation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_facturation')">
                                        {{ getErrorsField('date_facturation') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_facturation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                              </b-col>
                            </b-row>
            <hr/>

            <b-row class="justify-content-sm-center">
              <b-button
                @click="onSubmit"
                variant="primary">
                {{ $t("message.enregistrerFacture") }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require("jquery");
import { mapGetters } from "vuex";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import SlimSelect from "slim-select";
import moment from "moment";
import AppConfig from "../../constants/AppConfig";
export default {
  name: "Add",
  computed: {
    ...mapGetters([
      "hasAdminRole",
      "subscribers",
      "errors",
      "hasGestionnaireRole",
      "hasMedecinControleRole",
      "hasAssistante",
      "isComptable",
    ]),

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.isComptable || this.hasAssistante
      );
    },
            mSubscribers: function() {
                let sArray = [];

                _.forEach(this.subscribers, function(subscriber) {
                    let s = {};

                    if((typeof subscriber.user == 'object') && (!_.isNull(subscriber.user))) {
                        let prenom = subscriber.user.prenom ? subscriber.user.prenom : '';
                        prenom =  prenom.toLowerCase();
                        s.nom =  (subscriber.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        s.id = subscriber.user.id;
                        s.slug = subscriber.user.slug;
                        s.patients = subscriber.patients;
                    }

                    sArray.push(s);
                });
               
                return sArray;
            },
      
  },

  data() {
    return {
        seen: false,
      prestations: [],
      continuer: false,
      patients: [],
      prestationSelect: Object,
      selectMontant:[
        {
          id:15000,
          montant:15000
        },
        {
          id:10000,
          montant:10000
        }
      ],
      prestation: null,
      total: 0,
      form: {
        prestation: [],
        souscripteur: null,
        association_id: null,
        patient_id: null,
        date_facturation: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  validations() {
    return {
      form: {
        patient_id: { required },
        amount: {},
        date_facturation: { required },
        souscripteur: { required },
      },
    };
  },
  watch:{

  },
  methods: {

    getMontantTotal(){
      return this.form.amount;
    },

    getMedicalAdvicesPatient(event) {

      this.patients = [];
      //let mArray = this.mSubscribers.filter(i => i.id === event.target.value)
      let mArray = _.find(this.mSubscribers, function(obj) {
      
          return obj.id == event.target.value;
      })

      this.patients = mArray.patients;

    },

    validerForm(evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.continuer = true;
      }
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.$touch();

      if(!this.$v.$invalid) {
      let args = {
        patient_id: this.form.patient_id,
        souscripteur_id: this.form.souscripteur,
        amount:  this.form.amount,
        date_facturation: this.form.date_facturation
      };

      let successMessage = this.$i18n.t("message.factureCreated");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      this.$store.dispatch("getPaymentLink", {
        args,
        errorMessages,
        successMessage,
      });
      }
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return "";
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", { field });

      this.getErrorsField(field);
    },
            getSubscribers() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getSubscribers', { args : args });
            },

  },

  mounted() {

    // Fetch subscriber list
    this.getSubscribers();

    new SlimSelect({
      select: "#nomPatient",
      placeholder: "Select patient",
      limit: 1,
    });
    new SlimSelect({
      select: "#souscripteur",
      placeholder: "Select souscripteur",
      limit: 1,
    });
  },
};
</script>

<style scoped>
@import "~slim-select/dist/slimselect.min.css";
.truncate {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
